import { api } from './api';

export type AspectRatio = 'widescreen' | 'widescreen-portrait' | 'a4' | 'a4-landscape' | 'square';

export interface GenerateImageParams {
  prompt: string;
  promptType: string;
  aspectRatio: AspectRatio;
  imageStyle?: string;
  sourceTaskExecutionId?: string;
  sourceImageS3Key?: string;
}

export interface GenerateImageResult {
  imageId: string;
  status: 'generating';
}

export interface ImageTaskStatus {
  status: 'pending' | 'complete' | 'failed';
  imageId: string;
}

export async function generateSessionImage(
  sessionId: string,
  params: GenerateImageParams
): Promise<GenerateImageResult> {
  const response = await api.post(`/api/sessions/${sessionId}/generate-image`, params);
  return response.data;
}

export async function getImageTaskStatus(
  sessionId: string,
  imageId: string
): Promise<ImageTaskStatus> {
  const response = await api.get(`/api/sessions/${sessionId}/image-tasks/${imageId}`);
  return response.data;
}

export async function updateImageStyle(
  sessionId: string,
  imageStyle: string
): Promise<void> {
  await api.patch(`/api/sessions/${sessionId}/image-style`, { imageStyle });
}

export const ASPECT_RATIO_SIZES: Record<AspectRatio, string> = {
  widescreen: '1536×864',
  'widescreen-portrait': '864×1536',
  a4: '1120×1584',
  'a4-landscape': '1584×1120',
  square: '1024×1024',
};

export const ASPECT_RATIO_LABELS: Record<AspectRatio, string> = {
  widescreen: '16:9 Landscape',
  'widescreen-portrait': '9:16 Portrait',
  a4: 'A4 Portrait',
  'a4-landscape': 'A4 Landscape',
  square: 'Square',
};
